import { ref } from 'vue'
import type { CardT } from '@/types/Game'

// Shared state across all component instances
const cardOrder = ref<Record<string, string[]>>({})

export const useCardOrdering = () => {
  // Get the card order for a specific game
  const getCardOrder = (gameId: string): string[] => {
    return cardOrder.value[gameId] || []
  }

  // Apply user's preferred order to a list of cards
  const applyCardOrder = (cards: CardT[], gameId: string): CardT[] => {
    // Filter out invalid cards first
    const validCards = cards.filter(card => card && card.id)

    const savedOrder = getCardOrder(gameId)
    if (!savedOrder.length) return validCards

    // Create a map for quick lookup
    const cardMap = new Map(validCards.map(card => [card.id, card]))

    // First, add cards in the saved order (if they still exist)
    const orderedCards: CardT[] = []
    const usedCardIds = new Set<string>()

    savedOrder.forEach(cardId => {
      const card = cardMap.get(cardId)
      if (card && card.id) {
        orderedCards.push(card)
        usedCardIds.add(cardId)
      }
    })

    // Then add any new cards that weren't in the saved order
    validCards.forEach(card => {
      if (card && card.id && !usedCardIds.has(card.id)) {
        orderedCards.push(card)
      }
    })

    return orderedCards
  }

  return {
    getCardOrder,
    applyCardOrder
  }
}
